import i18n from './i18n'

import css from './SelectedFilters.module.css'

import type { Filter, Props } from '#/global/component/Product/ProductFilters'

export const SelectedFilters = ({ filters, handleChange, lang, values }: Props) => {
    if (!Object.values(values).some(x => x.length > 0)) {
        return null
    }

    const clearFilterValue = (filter: Filter, value: string | number) => {
        const selected = [...values[filter.id]] as string[]
        const index = selected.indexOf(value as string)
        selected.splice(index, 1)
        return handleChange(filter.id, selected)
    }

    const t = i18n[lang]

    return (
        <div className={`r-selected-filters ${css.container}`}>
            <div className={css.title}>{t.title}</div>
            <div className={css.filters}>
                {Object.entries(values).map(([filterId, values]) => {
                    const filter = filters.find(f => f.id === filterId)
                    if (!filter) {
                        return null
                    }

                    if (filterId === 'PRICE' && values.length === 2) {
                        return (
                            <SelectedFilter
                                key={filterId}
                                filter={filter}
                                onClick={() => handleChange(filter.id, [])}
                                title={`${values[0].toLocaleString('cs-CZ')} - ${values[1].toLocaleString('cs-CZ')}`}
                            />
                        )
                    }
                    return values.map(v => (
                        <SelectedFilter
                            key={v}
                            filter={filter}
                            onClick={() => clearFilterValue(filter, v)}
                            title={filter.values.find(x => x.value === v)?.title ?? ''}
                        />
                    ))
                })}
                <div className={css.clear}>
                    <a href={void 0} onClick={() => handleChange('ALL', [])}>
                        {t.clearAll}
                    </a>
                </div>
            </div>
        </div>
    )
}

interface SelectedFilterProps {
    filter: Filter
    onClick: () => void
    title: string
}
const SelectedFilter = ({ filter, onClick, title }: SelectedFilterProps) => (
    <div className={css.fitler}>
        <div className={css.filterTitle}>
            {filter.title}
            :
        </div>
        <div className={css.filterValue}>{title}</div>
        <img
            className={css.filterRemove}
            onClick={onClick}
            src="https://cdn1.idek.cz/file/icon-cancel-33c97f2e.svg"
            width={16}
            height={16}
        />
    </div>
)
